/**
 * NativeWaves Showcase API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class CollectionsApi extends runtime.BaseAPI {
    /**
     * This is an endpoint to keep compatibility with the old access code system. It should not be used for new access keys.
     * Create a custom showcase collection access key to support obsolete access codes.
     */
    async collectionsCollectionIdAccessKeysCustomPostRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdAccessKeysCustomPost.');
        }
        if (requestParameters.showcaseCollectionCustomAccessKeyInsert === null ||
            requestParameters.showcaseCollectionCustomAccessKeyInsert === undefined) {
            throw new runtime.RequiredError('showcaseCollectionCustomAccessKeyInsert', 'Required parameter requestParameters.showcaseCollectionCustomAccessKeyInsert was null or undefined when calling collectionsCollectionIdAccessKeysCustomPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}/accessKeys/$custom`.replace(`{${'collectionId'}}`, String(requestParameters.collectionId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.showcaseCollectionCustomAccessKeyInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * This is an endpoint to keep compatibility with the old access code system. It should not be used for new access keys.
     * Create a custom showcase collection access key to support obsolete access codes.
     */
    async collectionsCollectionIdAccessKeysCustomPost(requestParameters, initOverrides) {
        const response = await this.collectionsCollectionIdAccessKeysCustomPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of access keys of a showcase collection.
     */
    async collectionsCollectionIdAccessKeysGetRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdAccessKeysGet.');
        }
        const queryParameters = {};
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}/accessKeys`.replace(`{${'collectionId'}}`, String(requestParameters.collectionId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of access keys of a showcase collection.
     */
    async collectionsCollectionIdAccessKeysGet(requestParameters, initOverrides) {
        const response = await this.collectionsCollectionIdAccessKeysGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a showcase collection access key.
     */
    async collectionsCollectionIdAccessKeysKeyIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdAccessKeysKeyIdDelete.');
        }
        if (requestParameters.keyId === null ||
            requestParameters.keyId === undefined) {
            throw new runtime.RequiredError('keyId', 'Required parameter requestParameters.keyId was null or undefined when calling collectionsCollectionIdAccessKeysKeyIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}/accessKeys/{keyId}`
                .replace(`{${'collectionId'}}`, String(requestParameters.collectionId))
                .replace(`{${'keyId'}}`, String(requestParameters.keyId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a showcase collection access key.
     */
    async collectionsCollectionIdAccessKeysKeyIdDelete(requestParameters, initOverrides) {
        await this.collectionsCollectionIdAccessKeysKeyIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a showcase collection access key.
     */
    async collectionsCollectionIdAccessKeysKeyIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdAccessKeysKeyIdGet.');
        }
        if (requestParameters.keyId === null ||
            requestParameters.keyId === undefined) {
            throw new runtime.RequiredError('keyId', 'Required parameter requestParameters.keyId was null or undefined when calling collectionsCollectionIdAccessKeysKeyIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}/accessKeys/{keyId}`
                .replace(`{${'collectionId'}}`, String(requestParameters.collectionId))
                .replace(`{${'keyId'}}`, String(requestParameters.keyId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a showcase collection access key.
     */
    async collectionsCollectionIdAccessKeysKeyIdGet(requestParameters, initOverrides) {
        const response = await this.collectionsCollectionIdAccessKeysKeyIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a showcase collection access key.
     */
    async collectionsCollectionIdAccessKeysKeyIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdAccessKeysKeyIdPatch.');
        }
        if (requestParameters.keyId === null ||
            requestParameters.keyId === undefined) {
            throw new runtime.RequiredError('keyId', 'Required parameter requestParameters.keyId was null or undefined when calling collectionsCollectionIdAccessKeysKeyIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}/accessKeys/{keyId}`
                .replace(`{${'collectionId'}}`, String(requestParameters.collectionId))
                .replace(`{${'keyId'}}`, String(requestParameters.keyId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.showcaseCollectionAccessKeyEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a showcase collection access key.
     */
    async collectionsCollectionIdAccessKeysKeyIdPatch(requestParameters, initOverrides) {
        const response = await this.collectionsCollectionIdAccessKeysKeyIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a showcase collection access sharing link
     */
    async collectionsCollectionIdAccessKeysKeyIdShareGetRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdAccessKeysKeyIdShareGet.');
        }
        if (requestParameters.keyId === null ||
            requestParameters.keyId === undefined) {
            throw new runtime.RequiredError('keyId', 'Required parameter requestParameters.keyId was null or undefined when calling collectionsCollectionIdAccessKeysKeyIdShareGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}/accessKeys/{keyId}/share`
                .replace(`{${'collectionId'}}`, String(requestParameters.collectionId))
                .replace(`{${'keyId'}}`, String(requestParameters.keyId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a showcase collection access sharing link
     */
    async collectionsCollectionIdAccessKeysKeyIdShareGet(requestParameters, initOverrides) {
        const response = await this.collectionsCollectionIdAccessKeysKeyIdShareGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a showcase collection access key link stats.
     */
    async collectionsCollectionIdAccessKeysKeyIdStatsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdAccessKeysKeyIdStatsGet.');
        }
        if (requestParameters.keyId === null ||
            requestParameters.keyId === undefined) {
            throw new runtime.RequiredError('keyId', 'Required parameter requestParameters.keyId was null or undefined when calling collectionsCollectionIdAccessKeysKeyIdStatsGet.');
        }
        const queryParameters = {};
        if (requestParameters.durationDays !== undefined) {
            queryParameters['durationDays'] = requestParameters.durationDays;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}/accessKeys/{keyId}/stats`
                .replace(`{${'collectionId'}}`, String(requestParameters.collectionId))
                .replace(`{${'keyId'}}`, String(requestParameters.keyId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a showcase collection access key link stats.
     */
    async collectionsCollectionIdAccessKeysKeyIdStatsGet(requestParameters, initOverrides) {
        const response = await this.collectionsCollectionIdAccessKeysKeyIdStatsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a showcase collection access key.
     */
    async collectionsCollectionIdAccessKeysPostRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdAccessKeysPost.');
        }
        if (requestParameters.showcaseCollectionAccessKeyInsert === null ||
            requestParameters.showcaseCollectionAccessKeyInsert === undefined) {
            throw new runtime.RequiredError('showcaseCollectionAccessKeyInsert', 'Required parameter requestParameters.showcaseCollectionAccessKeyInsert was null or undefined when calling collectionsCollectionIdAccessKeysPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}/accessKeys`.replace(`{${'collectionId'}}`, String(requestParameters.collectionId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.showcaseCollectionAccessKeyInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a showcase collection access key.
     */
    async collectionsCollectionIdAccessKeysPost(requestParameters, initOverrides) {
        const response = await this.collectionsCollectionIdAccessKeysPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a showcase collection.
     */
    async collectionsCollectionIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}`.replace(`{${'collectionId'}}`, String(requestParameters.collectionId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a showcase collection.
     */
    async collectionsCollectionIdDelete(requestParameters, initOverrides) {
        await this.collectionsCollectionIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a showcase collection.
     */
    async collectionsCollectionIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdGet.');
        }
        const queryParameters = {};
        if (requestParameters.locale !== undefined) {
            queryParameters['locale'] = requestParameters.locale;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}`.replace(`{${'collectionId'}}`, String(requestParameters.collectionId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a showcase collection.
     */
    async collectionsCollectionIdGet(requestParameters, initOverrides) {
        const response = await this.collectionsCollectionIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a showcase collection.
     */
    async collectionsCollectionIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdPatch.');
        }
        if (requestParameters.showcaseCollectionEdit === null ||
            requestParameters.showcaseCollectionEdit === undefined) {
            throw new runtime.RequiredError('showcaseCollectionEdit', 'Required parameter requestParameters.showcaseCollectionEdit was null or undefined when calling collectionsCollectionIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}`.replace(`{${'collectionId'}}`, String(requestParameters.collectionId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.showcaseCollectionEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a showcase collection.
     */
    async collectionsCollectionIdPatch(requestParameters, initOverrides) {
        const response = await this.collectionsCollectionIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of entries of a showcase collection.
     */
    async collectionsCollectionIdShowcasesGetRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdShowcasesGet.');
        }
        const queryParameters = {};
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.locale !== undefined) {
            queryParameters['locale'] = requestParameters.locale;
        }
        if (requestParameters.includeMediaNotFound !== undefined) {
            queryParameters['includeMediaNotFound'] =
                requestParameters.includeMediaNotFound;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}/showcases`.replace(`{${'collectionId'}}`, String(requestParameters.collectionId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of entries of a showcase collection.
     */
    async collectionsCollectionIdShowcasesGet(requestParameters, initOverrides) {
        const response = await this.collectionsCollectionIdShowcasesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a showcase collection entry.
     */
    async collectionsCollectionIdShowcasesPostRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdShowcasesPost.');
        }
        if (requestParameters.showcaseEntryInsert === null ||
            requestParameters.showcaseEntryInsert === undefined) {
            throw new runtime.RequiredError('showcaseEntryInsert', 'Required parameter requestParameters.showcaseEntryInsert was null or undefined when calling collectionsCollectionIdShowcasesPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}/showcases`.replace(`{${'collectionId'}}`, String(requestParameters.collectionId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.showcaseEntryInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a showcase collection entry.
     */
    async collectionsCollectionIdShowcasesPost(requestParameters, initOverrides) {
        const response = await this.collectionsCollectionIdShowcasesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a showcase collection entry.
     */
    async collectionsCollectionIdShowcasesShowcaseIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdShowcasesShowcaseIdDelete.');
        }
        if (requestParameters.showcaseId === null ||
            requestParameters.showcaseId === undefined) {
            throw new runtime.RequiredError('showcaseId', 'Required parameter requestParameters.showcaseId was null or undefined when calling collectionsCollectionIdShowcasesShowcaseIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}/showcases/{showcaseId}`
                .replace(`{${'collectionId'}}`, String(requestParameters.collectionId))
                .replace(`{${'showcaseId'}}`, String(requestParameters.showcaseId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a showcase collection entry.
     */
    async collectionsCollectionIdShowcasesShowcaseIdDelete(requestParameters, initOverrides) {
        await this.collectionsCollectionIdShowcasesShowcaseIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a drm license information for showcase collection entry.
     */
    async collectionsCollectionIdShowcasesShowcaseIdDrmLicenseInfoGetRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdShowcasesShowcaseIdDrmLicenseInfoGet.');
        }
        if (requestParameters.showcaseId === null ||
            requestParameters.showcaseId === undefined) {
            throw new runtime.RequiredError('showcaseId', 'Required parameter requestParameters.showcaseId was null or undefined when calling collectionsCollectionIdShowcasesShowcaseIdDrmLicenseInfoGet.');
        }
        const queryParameters = {};
        if (requestParameters.locale !== undefined) {
            queryParameters['locale'] = requestParameters.locale;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}/showcases/{showcaseId}/drmLicenseInfo`
                .replace(`{${'collectionId'}}`, String(requestParameters.collectionId))
                .replace(`{${'showcaseId'}}`, String(requestParameters.showcaseId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a drm license information for showcase collection entry.
     */
    async collectionsCollectionIdShowcasesShowcaseIdDrmLicenseInfoGet(requestParameters, initOverrides) {
        const response = await this.collectionsCollectionIdShowcasesShowcaseIdDrmLicenseInfoGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a showcase collection entry.
     */
    async collectionsCollectionIdShowcasesShowcaseIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdShowcasesShowcaseIdGet.');
        }
        if (requestParameters.showcaseId === null ||
            requestParameters.showcaseId === undefined) {
            throw new runtime.RequiredError('showcaseId', 'Required parameter requestParameters.showcaseId was null or undefined when calling collectionsCollectionIdShowcasesShowcaseIdGet.');
        }
        const queryParameters = {};
        if (requestParameters.locale !== undefined) {
            queryParameters['locale'] = requestParameters.locale;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}/showcases/{showcaseId}`
                .replace(`{${'collectionId'}}`, String(requestParameters.collectionId))
                .replace(`{${'showcaseId'}}`, String(requestParameters.showcaseId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a showcase collection entry.
     */
    async collectionsCollectionIdShowcasesShowcaseIdGet(requestParameters, initOverrides) {
        const response = await this.collectionsCollectionIdShowcasesShowcaseIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a showcase collection entry.
     */
    async collectionsCollectionIdShowcasesShowcaseIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.collectionId === null ||
            requestParameters.collectionId === undefined) {
            throw new runtime.RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling collectionsCollectionIdShowcasesShowcaseIdPatch.');
        }
        if (requestParameters.showcaseId === null ||
            requestParameters.showcaseId === undefined) {
            throw new runtime.RequiredError('showcaseId', 'Required parameter requestParameters.showcaseId was null or undefined when calling collectionsCollectionIdShowcasesShowcaseIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections/{collectionId}/showcases/{showcaseId}`
                .replace(`{${'collectionId'}}`, String(requestParameters.collectionId))
                .replace(`{${'showcaseId'}}`, String(requestParameters.showcaseId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.showcaseEntryEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a showcase collection entry.
     */
    async collectionsCollectionIdShowcasesShowcaseIdPatch(requestParameters, initOverrides) {
        const response = await this.collectionsCollectionIdShowcasesShowcaseIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of showcase collections. If the filter: \'query\' is used, then the max total return count is limited to 10 000 even with pagination.
     */
    async collectionsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling collectionsGet.');
        }
        const queryParameters = {};
        if (requestParameters.environmentId !== undefined) {
            queryParameters['environmentId'] = requestParameters.environmentId;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.locale !== undefined) {
            queryParameters['locale'] = requestParameters.locale;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of showcase collections. If the filter: \'query\' is used, then the max total return count is limited to 10 000 even with pagination.
     */
    async collectionsGet(requestParameters, initOverrides) {
        const response = await this.collectionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new showcase collection.
     */
    async collectionsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.showcaseCollectionInsert === null ||
            requestParameters.showcaseCollectionInsert === undefined) {
            throw new runtime.RequiredError('showcaseCollectionInsert', 'Required parameter requestParameters.showcaseCollectionInsert was null or undefined when calling collectionsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/collections`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.showcaseCollectionInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new showcase collection.
     */
    async collectionsPost(requestParameters, initOverrides) {
        const response = await this.collectionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const CollectionsGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
//# sourceMappingURL=CollectionsApi.js.map